import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';
import type {Component} from 'grapesjs';

/**
 * Listeners related to the StyleManager
 * @param {object} opt The grapesjs config object
 */
export default (opt: PrimaryConfigOptions): void => {
  const editor = opt.editor;

  editor.on('component:styleUpdate:font-size', (model: Component) => {
    let component: Component;
    if (typeof model === 'undefined' && editor.getSelected() !== undefined) {
      component = editor.getSelected() as Component;
    } else {
      component = model;
    }
    const style = component?.getStyle();

    if (typeof style?.['font-size'] !== 'undefined') {
      const fontSize = style['font-size'] as string;

      if (parseInt(fontSize, 10) > 20) {
        component.getEl()?.setAttribute('data-is-header', '1');
      } else {
        component.getEl()?.setAttribute('data-is-header', '0');
      }
    }
  });

  editor.on('component:styleUpdate:border-width', (model: Component) => {
    let component;

    if (typeof model === 'undefined') {
      component = editor.getSelected();
    } else {
      component = model;
    }
    const style = component?.getStyle();

    if (style && !style['border-style']) {
      component?.addStyle({'border-style': 'solid'});
    }
  });

  editor.on('component:styleUpdate:padding', (component: Component) => {
    editor.runCommand(window.PMW.emails.commands.HANDLE_TABLE_PADDING, {
      component: component,
    });
    highlightPaddingOnUpdate(component);
  });

  editor.on('component:styleUpdate:padding-top', (component: Component) => {
    highlightPaddingOnUpdate(component);
  });

  editor.on('component:styleUpdate:padding-bottom', (component: Component) => {
    highlightPaddingOnUpdate(component);
  });

  editor.on('component:styleUpdate:padding-right', (component: Component) => {
    highlightPaddingOnUpdate(component);
  });

  editor.on('component:styleUpdate:padding-left', (component: Component) => {
    highlightPaddingOnUpdate(component);
  });

  editor.on('component:styleUpdate:pmw-cell-spacing', (component: Component) => {
    editor.runCommand(window.PMW.emails.commands.HIGHLIGHT_CELL_SPACING, {component});
  });

  const highlightPaddingOnUpdate = (component: Component): void => {
    editor.runCommand(window.PMW.emails.commands.HIGHLIGHT_COMPONENT_PADDING, {component});
  };

  editor.on('component:styleUpdate:vertical-align', (model: Component | undefined) => {
    let component;
    if (typeof model === 'undefined') {
      component = editor.getSelected();
    } else {
      component = model;
    }

    if (component && (component.get('type') === window.PMW.emails.components.table.PMW_TABLE || component.get('type') === window.PMW.emails.components.table.PMW_SECTION)) {
      const parentTable = component.getEl() as HTMLElement,
        currentAlignment = component.getStyle()['vertical-align'];

      // @ts-ignore
      $(parentTable).find('td').css({'vertical-align': currentAlignment});
    }
  });

  editor.on('load', function () {
    editor.runCommand(window.PMW.emails.commands.TOGGLE_STYLEMANAGER_SCROLL_LISTENER, {toggleOn: true});
    editor.UndoManager.clear();
  });
};
